import { render, staticRenderFns } from "./userMain.vue?vue&type=template&id=c2f15024&scoped=true"
import script from "./userMain.vue?vue&type=script&lang=js"
export * from "./userMain.vue?vue&type=script&lang=js"
import style0 from "./userMain.vue?vue&type=style&index=0&id=c2f15024&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f15024",
  null
  
)

export default component.exports